export default __webpack_public_path__ + "images/KM.f96a505.png";